<template>
  <div :class="[
      'steps',
      'steps--horizontal',
      { 'is-center': isCenter}
    ]
  ">
    <div
      :class="[
        'step',
        { 'is-finish': step >= item.id },
      ]"
      v-for="item in list"
      :key="item.id"
    >
      <div class="step-head">
        <div
          class="step-line"
          :class="{'is-finish': step >= item.id}"
        >
          <i
            class="step-line-inner"
            :class="{'is-finish': step >= item.id+1}"
          />
        </div>
        <div
          class="step-icon"
          :class="{'is-finish': step >= item.id}"
        >
          <i
            class="step-icon-inner"
            :class="{'is-finish': step >= item.id}"
          />
        </div>
      </div>
      <div
        class="step-main"
        :class="{'is-finish': step >= item.id}"
      >
        <div
          class="step-title"
          v-show="item.title"
        >
          {{ $t(item.title) }}
        </div>
        <div
          class="step-desc"
          v-show="item.desc"
        >
          {{ $t(item.desc) }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    // 当前步骤
    step: {
      type: [String, Number],
      required: true
    },
    // 是否居中
    isCenter: {
      type: Boolean,
      default: true
    },
    /**
     * 展示列表,title与desc 非必传
     * 格式：[
     *  {id:'', title:'', desc:''}
     * ]
     */
    list: {
      type: Array,
      required: true
    }
  }
}
</script>
<style lang="less" scoped>
.steps {
  display: flex;
  width: 700px;
  &--horizontal {
    white-space: nowrap;
  }
  .is-finish {
    color: @blue;
  }
  .step {
    flex-basis: 50%;
    margin-right: 0;
    color: @blackLess;

    &:last-of-type {
      flex-basis: auto;
      flex-shrink: 0;
      flex-grow: 0;
      max-width: 33.3333%;
      .step-line {
        display: none;
      }
    }
    .step-head {
      position: relative;
      width: 100%;
      .step-line {
        position: absolute;
        border-color: inherit;
        background-color: @grayLess20;
        height: 4px;
        top: 6px;
        left: 0;
        right: 0;
        .step-line-inner {
          display: block;
          border: 2px solid;
          border-color: @blue;
          background-color: @blue;
          transition: 0.15s ease-out;
          box-sizing: border-box;
          width: 0;
          height: 0;
          &.is-finish {
            width: 100%;
          }
        }
      }
      .step-icon {
        position: relative;
        z-index: 1;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        width: 12px;
        height: 12px;
        font-size: 14px;
        box-sizing: border-box;
        transition: 0.15s ease-out;
        .step-icon-inner {
          width: 12px;
          height: 12px;
          border-radius: 100%;

          background: @grayLess20;
          &.is-finish {
            background: @blue;
          }
        }
      }
    }
    .step-main {
      white-space: normal;
      text-align: left;
      .step-title {
        margin-top: 10px;
        font-size: 16px;
        line-height: 16px;
      }
      .step-desc {
        margin-top: 10px;
        font-size: 14px;
        font-weight: 300;
        line-height: 20px;
      }
    }
  }

  &.is-center {
    text-align: center;
    .step {
      flex-basis: 25%;
      .step-head {
        .step-line {
          left: 50%;
          right: -50%;
        }
      }
    }
    .step-main {
      text-align: center;
    }
  }
}
</style>
